import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const TextChunkEntitySchema = z.object({
  textChunkEntityId: PrimaryKeySchema,
  textChunkId: PrimaryKeySchema,
  entityId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
});

export type TextChunkEntity = z.infer<typeof TextChunkEntitySchema>;

export const TextChunkEntitiesSchema = z.array(TextChunkEntitySchema);

export type TextChunkEntities = z.infer<typeof TextChunkEntitiesSchema>;

export const TextChunkEntityFiltersSchema = z
  .object({
    textChunkEntityIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    textChunkIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    entityIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type TextChunkEntityFilters = z.infer<
  typeof TextChunkEntityFiltersSchema
>;
